'use client'
import React, { memo, useState } from 'react'
import { Skeleton } from '@mantine/core'

const DescriptionSection = ({ loading, data, isLong, words }) => {
  const [showFull, setShowFull] = useState(false)

  const displayedText = showFull
    ? data?.data?.summary
    : words?.slice(0, 60).join(' ') + (isLong ? '...' : '')

  return (
    <div className='w-full'>
      {loading || !data ? (
        <div>
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} height={20} mt='sm' radius='sm' />
          ))}
        </div>
      ) : (
        <p className='font-normal text-[13px] leading-[187%] tracking-normal text-[#191919] text-justify md:mx-0 mx-[10px]'>
          {data?.data?.summary ? displayedText : 'No Summary Available'}
        </p>
      )}

      {!loading && isLong && (
        <p
          onClick={() => setShowFull(!showFull)}
          className='text-[#008CB5] font-medium text-[13px] leading-[200%] tracking-normal mt-2 cursor-pointer hover:underline transition-colors duration-200 md:mx-0 mx-[10px]'
          type='button'
          aria-expanded={showFull}
          aria-controls='full-description'
          id='toggle-description-button'
          data-testid='toggle-description-button'
          data-cy='toggle-description-button'
          aria-label={showFull ? 'Read less' : 'Read more'}
          role='button'
          tabIndex={0}
        >
          {showFull ? 'Read less' : 'Read more'}
        </p>
      )}
    </div>
  )
}

export default memo(DescriptionSection)
